/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_PRESENTATIONS } from "../graphql/getPresentations.query";
import { pretty } from "@vlinder-web/utils-react";
import { PAYMENT_REPORT } from "../graphql/getPaymentReport.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPaymentReportMethods extends IPluginMethodMap {
  getPaymentReport(args: any): Promise<any>;
}

export class PaymentReportService implements IAgentPlugin {
  readonly methods: IPaymentReportMethods;

  constructor() {
    this.methods = {
      getPaymentReport: this.getPaymentReport.bind(this),
    };
  }

  async getPaymentReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    let filters = {};
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        const defaultPresentation =
          _res?.data?.getPresentations?.content[0]?.id;
                if (args?.presentation === "" || args?.presentation === null || args?.presentation === undefined) {
          args.presentation = defaultPresentation;
        }
        filters = {
          presentation: {
                        eq: args.presentation
                    }
                }
        if (args?.email && args?.email !== null && args?.email !== "") {
          filters = {
            ...filters,
            CreatedByUserName: {
                            contains: args?.email
                        }
                    }
        }
                if (args?.startDate && args?.startDate !== null && args?.startDate !== "" && args?.endDate && args?.endDate !== null && args?.endDate !== "") {
          filters = {
            ...filters,
            createdAt: {
              gte: args?.startDate,
              lte: args?.endDate,
        }
                    }
                }
        console.log("payment==>", filters);
        const res = await client.query({
          query: PAYMENT_REPORT,
          variables: {
            filters: filters,
            options: {
              limit: 10000,
              skip: 0,
            },
          },
          fetchPolicy: "network-only",
        });

        const csvUrl = res?.data?.getPayTxReport?.csvUrl;
        if (!csvUrl || !is.existy(csvUrl) || String(csvUrl).trim() === "") {
          throw new Error("Report URL was not returned by the server");
        }

        return res;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  // private convertCriteria(criteria : any) {
  //   const result: any = {};
  //   for (const key in criteria) {
  //     result[key] = { contains: criteria[key] };
  //   }
  //   return result;
  // }
}
